import classNames from "classnames";
import {observer} from 'mobx-react';
import {useContext} from 'react';

import Button from "../utilities/Button";
import ClickableLink from "../utilities/ClickableLink";
import FlatIcon from "../utilities/FlatIcon";
import FontAwesome from "../utilities/FontAwesome";
import PhoneNumber from "../utilities/PhoneNumber";
import {StoreContext} from "../../stores/StoreLoader";

import styles from './styles/FooterCS.module.scss';

const addressColumnClassName = classNames({
    [styles.addressColumn]: true,
});

const FooterAddressColumn = observer(props => {
    const {organizationStore, modalStore, userStore, interfaceStore} = useContext(StoreContext);

    let location;
    if (interfaceStore.isSchoolBlocks) {
        // TODO: once schoolblocks locations are moved over to content items this should be refactored
        location = organizationStore.organization.locations?.[0];
    } else {
        const mapBlock = organizationStore.blocks.get('map');
        if (mapBlock) {
            location = mapBlock.items.find(item => item.published)?.json_data?.location;
        }
    }


    let locationBlock = null;
    if (location) {
        locationBlock =
            <address aria-label={`Address for ${organizationStore.organization.title}`} className={"notranslate"}>
                {location.address && <p>{location.address}</p>}
                {location.address2 && <p>{location.address2}</p>}
                <p>{location.city ? `${location.city}, ` : ""}{location.state ? `${location.state} ` : ""}{location.zip ? location.zip : ""}</p>
            </address>
    }

    const toggleInlineEditing = () => {
        modalStore.addModal({
            type: 'edit-location',
            key: 'edit-location',
            id: 'edit-location',
            handleUnmount: () => {
            },
        })
    };

    return (
        <div className={addressColumnClassName}>
            <h3 className={"notranslate"}>{organizationStore.organization.title}</h3>
            {userStore.isAdmin && !interfaceStore.isSchoolBlocks &&
            <Button id={'editAddress'} onClick={toggleInlineEditing}><FlatIcon ariaHidden={true} name={'flaticon-cogwheel'}/> Edit Address</Button>}
            {locationBlock && <div>
                <div>
                    <FlatIcon ariaHidden={true} name={'flaticon-map'}/>
                </div>
                <div>
                    {locationBlock}
                </div>
            </div>}
            {locationBlock && location.phone && <div>
                <div>
                    <FlatIcon title="Primary Phone Number" ariaHidden={true} name={'flaticon-telephone-of-old-design'}/>
                </div>
                <div>
                    <PhoneNumber ariaLabel={`Call primary phone number ${location.phone}`} isLinked number={location.phone}/>
                </div>
            </div>}
            {locationBlock && location.phone2 && <div>
                <div>
                    <FlatIcon title="Secondary Phone Number" ariaHidden={true} name={'flaticon-telephone-of-old-design'}/>
                </div>
                <div>
                    <PhoneNumber ariaLabel={`Call secondary phone number ${location.phone2}`} isLinked number={location.phone2}/>
                </div>
            </div>}
            {locationBlock && location.fax && <div>
                <div>
                    <FontAwesome title="Fax" ariaHidden={true} name={'fa-print'} prefix={'fas'}/>
                </div>
                <div>
                    <PhoneNumber ariaLabel={`Fax ${location.fax}`} number={location.fax}/>
                </div>
            </div>}
            {locationBlock && location.email && <div>
                <div>
                    <FontAwesome title="Email" ariaHidden={true} name={'fa-at'} prefix={'fas'}/>
                </div>
                <div>
                    <ClickableLink title="Email" href={`mailto://${location.email}`}>{location.email}</ClickableLink>
                </div>
            </div>}
        </div>
    )
});

export default FooterAddressColumn;
